var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 60,
    viewBox: "0 0 149 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6863 37.646L47.7673 29.8582V37.646H44.8389V13.8321H47.7673V27.8308L54.5575 20.0108H58.6445L50.3418 28.7962L58.6767 37.646H54.6863Z",
    fill: "url(#paint0_linear_23037_144161)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4913 28.1526C77.4913 28.7104 77.4591 29.3004 77.3948 29.9226H63.2995C63.4068 31.6604 63.9967 33.0227 65.0694 34.0096C66.1636 34.975 67.483 35.4577 69.0277 35.4577C70.2935 35.4577 71.3447 35.1681 72.1815 34.5888C73.0396 33.9881 73.6403 33.1943 73.9836 32.2074H77.1373C76.6654 33.9023 75.7214 35.2861 74.3054 36.3588C72.8894 37.41 71.1302 37.9357 69.0277 37.9357C67.3543 37.9357 65.8525 37.5602 64.5224 36.8093C63.2137 36.0584 62.1839 34.9965 61.433 33.6234C60.6821 32.2289 60.3066 30.6198 60.3066 28.7962C60.3066 26.9727 60.6714 25.3743 61.4008 24.0013C62.1302 22.6282 63.1493 21.577 64.458 20.8475C65.7882 20.0966 67.3114 19.7212 69.0277 19.7212C70.7011 19.7212 72.1815 20.0859 73.4687 20.8153C74.7559 21.5448 75.7428 22.5531 76.4294 23.8404C77.1373 25.1062 77.4913 26.5436 77.4913 28.1526ZM74.4663 27.5412C74.4663 26.4256 74.2196 25.4709 73.7261 24.6771C73.2327 23.8618 72.5569 23.2504 71.6987 22.8427C70.862 22.4137 69.9288 22.1991 68.899 22.1991C67.4187 22.1991 66.1529 22.6711 65.1016 23.6151C64.0718 24.5591 63.4818 25.8678 63.3317 27.5412H74.4663Z",
    fill: "url(#paint1_linear_23037_144161)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2627 28.7641C80.2627 26.9619 80.6274 25.3851 81.3568 24.0334C82.0863 22.6604 83.0839 21.5984 84.3497 20.8475C85.6369 20.0966 87.0743 19.7212 88.6619 19.7212C90.035 19.7212 91.3115 20.043 92.4915 20.6866C93.6714 21.3088 94.5725 22.1348 95.1947 23.1646V13.8321H98.1553V37.646H95.1947V34.3314C94.6154 35.3826 93.7573 36.2515 92.6202 36.9381C91.4831 37.6031 90.153 37.9357 88.6297 37.9357C87.0636 37.9357 85.6369 37.5495 84.3497 36.7771C83.0839 36.0048 82.0863 34.9214 81.3568 33.5269C80.6274 32.1323 80.2627 30.5448 80.2627 28.7641ZM95.1947 28.7962C95.1947 27.4661 94.9265 26.3076 94.3902 25.3207C93.8538 24.3338 93.1244 23.5829 92.2018 23.068C91.3008 22.5317 90.3032 22.2635 89.209 22.2635C88.1149 22.2635 87.1172 22.5209 86.2162 23.0358C85.3151 23.5507 84.5964 24.3016 84.06 25.2885C83.5237 26.2754 83.2555 27.4339 83.2555 28.7641C83.2555 30.1157 83.5237 31.2956 84.06 32.304C84.5964 33.2909 85.3151 34.0525 86.2162 34.5888C87.1172 35.1037 88.1149 35.3612 89.209 35.3612C90.3032 35.3612 91.3008 35.1037 92.2018 34.5888C93.1244 34.0525 93.8538 33.2909 94.3902 32.304C94.9265 31.2956 95.1947 30.1264 95.1947 28.7962Z",
    fill: "url(#paint2_linear_23037_144161)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.617 17.1467C104.059 17.1467 103.587 16.9536 103.201 16.5674C102.815 16.1813 102.621 15.7093 102.621 15.1515C102.621 14.5937 102.815 14.1217 103.201 13.7355C103.587 13.3493 104.059 13.1562 104.617 13.1562C105.153 13.1562 105.604 13.3493 105.968 13.7355C106.354 14.1217 106.548 14.5937 106.548 15.1515C106.548 15.7093 106.354 16.1813 105.968 16.5674C105.604 16.9536 105.153 17.1467 104.617 17.1467ZM106.033 20.0108V37.646H103.104V20.0108H106.033Z",
    fill: "url(#paint3_linear_23037_144161)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.616 19.689C121.761 19.689 123.499 20.3434 124.829 21.6521C126.16 22.9393 126.825 24.8058 126.825 27.2516V37.646H123.928V27.6699C123.928 25.9107 123.489 24.5698 122.609 23.6473C121.729 22.7033 120.528 22.2313 119.005 22.2313C117.46 22.2313 116.226 22.714 115.304 23.6795C114.403 24.6449 113.952 26.0501 113.952 27.8952V37.646H111.024V20.0108H113.952V22.5209C114.531 21.6199 115.315 20.9226 116.301 20.4292C117.31 19.9357 118.415 19.689 119.616 19.689Z",
    fill: "url(#paint4_linear_23037_144161)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.881 19.7212C140.404 19.7212 141.735 20.0537 142.872 20.7188C144.03 21.3839 144.888 22.2206 145.446 23.2289V20.0108H148.407V38.0322C148.407 39.6413 148.064 41.068 147.377 42.3123C146.691 43.5781 145.704 44.565 144.416 45.2729C143.151 45.9809 141.67 46.3349 139.975 46.3349C137.658 46.3349 135.727 45.7878 134.183 44.6937C132.638 43.5995 131.726 42.1085 131.447 40.2205H134.344C134.666 41.2932 135.331 42.1514 136.339 42.795C137.347 43.4601 138.559 43.7926 139.975 43.7926C141.584 43.7926 142.893 43.2885 143.901 42.2801C144.931 41.2718 145.446 39.8558 145.446 38.0322V34.3314C144.867 35.3612 144.009 36.2193 142.872 36.9059C141.735 37.5924 140.404 37.9357 138.881 37.9357C137.315 37.9357 135.888 37.5495 134.601 36.7771C133.335 36.0048 132.338 34.9214 131.608 33.5269C130.879 32.1323 130.514 30.5448 130.514 28.7641C130.514 26.9619 130.879 25.3851 131.608 24.0334C132.338 22.6604 133.335 21.5984 134.601 20.8475C135.888 20.0966 137.315 19.7212 138.881 19.7212ZM145.446 28.7962C145.446 27.4661 145.178 26.3076 144.642 25.3207C144.105 24.3338 143.376 23.5829 142.453 23.068C141.552 22.5317 140.555 22.2635 139.46 22.2635C138.366 22.2635 137.369 22.5209 136.468 23.0358C135.567 23.5507 134.848 24.3016 134.312 25.2885C133.775 26.2754 133.507 27.4339 133.507 28.7641C133.507 30.1157 133.775 31.2956 134.312 32.304C134.848 33.2909 135.567 34.0525 136.468 34.5888C137.369 35.1037 138.366 35.3612 139.46 35.3612C140.555 35.3612 141.552 35.1037 142.453 34.5888C143.376 34.0525 144.105 33.2909 144.642 32.304C145.178 31.2956 145.446 30.1264 145.446 28.7962Z",
    fill: "url(#paint5_linear_23037_144161)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.256 0.980741C40.3564 0.896835 40.4239 0.78014 40.4466 0.65127C40.4694 0.5224 40.4458 0.389645 40.3802 0.276455C40.3145 0.163265 40.2109 0.0769241 40.0878 0.0326798C39.9646 -0.0115645 39.8298 -0.0108621 39.7071 0.0346601L9.42641 11.6697C6.78011 12.6971 4.64765 14.7295 3.49441 17.3235C2.34117 19.9174 2.2608 22.8622 3.27084 25.5152L3.36482 25.7578C3.7196 26.5947 5.257 29.3632 10.1602 29.7574L30.1341 31.3645C30.4217 31.3879 30.6957 31.4967 30.921 31.677C31.1462 31.8573 31.3124 32.1009 31.3982 32.3764C31.4839 32.6519 31.4853 32.9467 31.4022 33.223C31.319 33.4993 31.1552 33.7444 30.9316 33.9268L0.1991 59.0193C0.0986829 59.1032 0.0311562 59.2199 0.00843322 59.3487C-0.0142897 59.4776 0.00924844 59.6104 0.0749132 59.7235C0.140578 59.8367 0.244111 59.9231 0.367262 59.9673C0.490414 60.0116 0.625245 60.0109 0.74793 59.9653L31.0256 48.3303C33.6725 47.3035 35.8056 45.2713 36.9595 42.6773C38.1133 40.0833 38.1941 37.1382 37.1842 34.4848L37.0569 34.1573C36.6445 33.2476 35.0737 30.6762 30.4343 30.2517L10.321 28.6355C10.0334 28.6121 9.75935 28.5033 9.53409 28.323C9.30883 28.1427 9.14263 27.8991 9.05689 27.6236C8.97114 27.3481 8.96975 27.0533 9.05289 26.777C9.13603 26.5007 9.29992 26.2556 9.52347 26.0732L40.256 0.980741Z",
    fill: "url(#paint6_linear_23037_144161)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23037_144161",
    x1: 44.8389,
    y1: 29.7456,
    x2: 148.407,
    y2: 29.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23037_144161",
    x1: 44.8389,
    y1: 29.7456,
    x2: 148.407,
    y2: 29.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23037_144161",
    x1: 44.8389,
    y1: 29.7456,
    x2: 148.407,
    y2: 29.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23037_144161",
    x1: 44.8389,
    y1: 29.7456,
    x2: 148.407,
    y2: 29.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23037_144161",
    x1: 44.8389,
    y1: 29.7456,
    x2: 148.407,
    y2: 29.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23037_144161",
    x1: 44.8389,
    y1: 29.7456,
    x2: 148.407,
    y2: 29.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23037_144161",
    x1: -2.2606e-7,
    y1: 30,
    x2: 40.4551,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A16AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336458,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633333,
    stopColor: "#479AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC9B8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a517e388530301f5d53b0f519b21d4c.svg";
export { ForwardRef as ReactComponent };